/***
**Module Name: Company details
 **File Name :  Company.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains compant tables details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import DataTable from 'react-data-table-component';

import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
import Sidebar from "../../../components/dashboard/sidebar";
import tmdbApi from "../../../api/tmdbApi";
import { useNavigate, Link } from "react-router-dom";
import Loader from "../../../components/loader";
import { useParams } from 'react-router-dom';
import moment from "moment";
import axios from 'axios';
import { contentContext } from "../../../context/contentContext";
import TableLoader from "../../../components/tableLoader";

let { lambda, appname } = window.app;



const ViewClientSessions = (props) => {
  const navigate = useNavigate();
  const [contactData, setContactData] = useState("");
  const [activities, setActivities] = useState([]);
  const { isLoading, setIsLoading, route, setRoute, setCurrentPage, setRowsPerPage, rowsPerPage, currentPageNew, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext);
  const { id } = useParams();
  const prevRoute = usePrevious(route)
  useEffect(() => {
    if (prevRoute != undefined && prevRoute != route) {
      setCurrentPage(1)
      setRowsPerPage(15)
    }
  }, [prevRoute]);
  const clientActivity = {
    loginTime: "22-Oct-2025 18:04:58",
    clientName: "Visited Marketplace",
    companyName: "Urvasi Entertainment",
    startTime: "22-Oct-2025, 6:36 pm",
    endTime: "22-Oct-2025, 9:25 pm",
    activities: [
      {
        pageVisited: "Marketplace",
        time: "05:42 PM",
        action: "Categories",
        actionDescription: "Visited Movies categories",
        duration: "02:00",
      },
      {
        pageVisited: "Marketplace",
        time: "05:50 PM",
        action: "Movies",
        actionDescription:
          "Titles: Love thy woman, A Man Hanged in Jai, Lord of the Rings, Starwars 3, Avengers",
        duration: "02:00",
      },
      {
        pageVisited: "Marketplace",
        time: "05:50 PM",
        action: "Advanced Search",
        actionDescription:
        {
          category: "Movies",
          titles: "Spiderman",
          languages: "Telugu, English, French, German",
          genre: "Action, Animation, Biblical, Biography",
        },
        duration: "02:00",
      },
      {
        pageVisited: "Marketplace",
        time: "05:50 PM",
        action: "Search",
        actionDescription: "Searched: Movies — Found: 8 Results",
        duration: "02:00",
      },
      {
        pageVisited: "Cart",
        time: "05:42 PM",
        action: "Added to cart",
        actionDescription:
          "Added Love thy woman, A Man Hanged in Jai, Lord of the Rings, Starwars 3, Avengers to cart",
        duration: "02:00",
      },
      {
        pageVisited: "Cart",
        time: "05:42 PM",
        action: "Enquire",
        actionDescription:
          "Enquired Love thy woman, A Man Hanged in Jai, Lord of the Rings, Starwars 3, Avengers",
        duration: "02:00",
      },
    ],
  };
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    setRoute("clientsessions")
    setActiveMenuId(300057)
    setActiveMenuObj({
      "Client Management": false,
      "Contact Management": false,
      "Reports": true
    })

    getClientSessions()
  }, []);



  const keyForRerender = `${rowsPerPage}_${clientActivity?.activities?.length}`;
  const handleBack = (e) => {
    GetTimeActivity()
    // props.setClick(false);
    navigate(-1);
  }
  const customSort = (rows, selector, direction) => {
    const sortedData = rows.slice().sort((rowA, rowB) => {
      // use the selector function to resolve your field names by passing the sort comparators
      // const aField = selector(rowA);
      const aField = String(selector(rowA)).toLowerCase();

      //  const bField = selector(rowB);
      const bField = String(selector(rowB)).toLowerCase();

      let comparison = 0;

      if (aField > bField) {
        comparison = 1;
      } else if (aField < bField) {
        comparison = -1;
      }

      return direction === 'desc' ? comparison * -1 : comparison;
    });

    // Log the sorted data to the console
    // setSortedRecomData(sortedData)
    global.exportExcelData = sortedData
    // console.log('Sorted Data------>:', sortedData);

    return sortedData;
  };


  const getClientSessions = () => {
    GetTimeActivity()
    // const valid = validate()
    // if(valid){
    setCurrentPage(1);


    setIsLoading(true)
    const token = localStorage.getItem("token")
    // let payload = {}
    // if (NameEmailSearch) {
    //     payload.search = NameEmailSearch;
    //   }

    //   if (fromdate) {
    //     payload.loginfromdate = fromdate;
    //   }

    //   if (todate) {
    //     payload.logintodate = todate;
    //   }

    axios({
      method: 'POST',
      url: lambda + '/sessionReports?appname=' + appname + "&token=" + token + "&userid=" + localStorage.getItem("userId") + "&id=" + id,
      //  data:payload
    })
      .then(function (response) {
        if (response?.data?.result == "Invalid token or Expired") {
          // setShowSessionPopupup(true)
        } else {
          console.log("response", response);
          //  setData(response?.data?.result?.data);
          global.exportExcelData = response?.data?.result?.data
          setContactData(response?.data?.result?.data?.[0] );
          console.log("activityData", response?.data?.result?.data?.[0]?.activity);
          setActivities(response?.data?.result?.data?.[0]?.activity ?? []);
          //  setContent(response?.data?.result);
          setIsLoading(false)
        }
      }).catch((err) => {
        console.log('error', err);
        // setTableErrMsg(true)
        setIsLoading(false);
      });
    // }
  }
  const columns = [
    {
      name: "Page Visited",
      selector: (row) => row.pageVisited,
      cell: (row) => (
        <div className="page-cell">
          <div className="icon-filled">
            <span className="material-icons page-icon">{row?.icon}</span>
          </div>
          <div className="page-name">{row.pageVisited}</div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Time",
      selector: (row) => row?.time ?? "",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row?.action,
      sortable: true,
    },
    {
      name: "Action Description",
      cell: (row) => {

        const desc = row?.actionDescription;

        // If string → 1 title; if array → array length
        const count = Array.isArray(desc) ? desc.length : (desc ? 1 : 0);

        // What to show: actual string OR joined values
        const displayText = Array.isArray(desc) ? desc.join(", ") : desc;
        return (
          <div style={{ whiteSpace: "normal" }}>
            {row.action === "Advanced Search" ? (
              <>
                <div className="d-flex justify-content-between">
                  <div>
                    <strong>Searched:</strong>
                  </div>
                  <div>
                    <strong>Found:</strong> {row?.totalCount} Results
                  </div>
                </div>
                <br />
                {/* Nested table */}
                <table
                  className="nested-table"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <tbody>
                    {(() => {
                      const mergedData = {

                        ...(row?.actionDescription?.contentSearch || {}),
                        ...(row?.actionDescription?.clientcontentSearch || {})
                      };


                      const formatKey = (key = "") => {
                        if (!key) return "";

                        // Special condition for IMDBrating
                        if (key.toLowerCase() === "imdbrating") {
                          return "IMDB Rating";
                        }

                        // Split camelCase, numbers, and underscores
                        let spaced = key
                          .replace(/[_\d]+/g, " ")             // underscores/numbers → space
                          .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase → space before caps
                          .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
                          .replace(/\s+/g, " ")                // collapse multiple spaces
                          .trim()
                          .toLowerCase();

                        // Common words for better spacing
                        console.log('key----->:', key);
                        const commonWords = ["no", "of", "episodes", "languages", "dubbing", "territories", "available", "rights", "release", "year", "category",
                          "video", "quality", "type", "title", "genre", "client", "rating", "lead", "artist", "band", "name", "sports", "stars", "director", "details"];

                        for (let word of commonWords) {
                          const regex = new RegExp(word, "gi");
                          spaced = spaced.replace(regex, (match) => ` ${match} `);
                        }

                        // Remove double spaces and capitalize each word
                        return spaced
                          .replace(/\s+/g, " ")
                          .trim()
                          .split(" ")
                          .map(
                            (word) =>
                              word.length > 1
                                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                : word.toUpperCase()
                          )
                          .join(" ");
                      };




                      const entries = Object.entries(mergedData);
                      console.log("entries", entries);

                      return entries.map(([key, value], i) => (
                        <tr key={i}>
                          <td><strong>{formatKey(key)}</strong></td>
                          <td>
                            {key === "noofepisodes" ? (
                              Array.isArray(value) ? (
                                value.join(", ")
                              ) : typeof value === "object" && value !== null ? (
                                <>
                                  {value?.noofepisodesfrom && <span>Min: {value.noofepisodesfrom}</span>}
                                  {value?.noofepisodesto && (
                                    <>
                                      {value?.noofepisodesfrom && " - "}
                                      <span>Max: {value.noofepisodesto}</span>
                                    </>
                                  )}
                                </>
                              ) : typeof value === "boolean" ? (
                                value.toString()
                              ) : (
                                value
                              )
                            ) : Array.isArray(value) ? (
                              value.join(", ")
                            ) : typeof value === "boolean" ? (
                              value.toString()
                            ) : (
                              value
                            )}
                          </td>

                        </tr>
                      ));
                    })()}
                  </tbody>
                </table>
              </>
            ) : (row.action === "Add preference" | row.action === "Update preference" || row.action === "Delete preference") ? (
              <>
                <div>
                  Preference {
                    row.action === "Add preference"
                      ? "added"
                      : row.action === "Update preference"
                        ? "updated"
                        : "deleted"
                  } by <strong>{row.actionDescription?.emailid}</strong>
                </div>

                <br />

                <table
                  className="nested-table"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <tbody>
                    {Object.entries(row.actionDescription)
                      .filter(([key]) => key !== "emailid") // hide emailid
                      .map(([key, value], i) => (
                        <tr key={i}>
                          <td><strong>{key}</strong></td>
                          <td>
                            {Array.isArray(value) ? value.join(", ") : value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            ) : row.action === "Downloaded file" ? (
              <div>Downloaded <strong>{row?.actionDescription}</strong> file</div>
            ) : row.action === "Recommend" ? (
              <div>Recommended <strong>{row?.actionDescription}</strong></div>
            ) : row.action === "Search" ? (
              <>
                <div>Searched: <strong>{row?.actionDescription?.contentSearch?.title}</strong></div>
                <div>Found: <strong>{row?.totalCount} Results</strong></div>
              </>
            ) : row.action === "Added to cart" && count <= 5 ? (
              <div> Added <strong>{displayText}</strong> to cart</div>
            ) : row.action === "Added to cart" && count > 5 ? (
              <div> Added <strong>{count}</strong> titles to cart</div>
            ) : row.action === "Removed from cart" && count <= 5 ? (
              <div> Removed <strong>{displayText}</strong> from cart</div>
            ) : row.action === "Removed from cart" && count > 5 ? (
              <div> Removed <strong>{count}</strong> titles from cart</div>
            ) : row.action === "Request Video" ? (
              <div> Requested <strong>{displayText}</strong> title</div>
            ) : row.action === "Click" ? (
              <div> Clicked <strong>{displayText}</strong> title</div>
            ) : row.action === "Categories" ? (
              <div> Visited <strong>{row.actionDescription?.contentSearch?.category?.[0] || "N/A"}</strong> categories</div>
            ) : row.action === "Enquiry" && count <= 5 ? (
              <div> Enquired <strong>{displayText}</strong> </div>
            ) : row.action === "Enquiry" && count > 5 ? (
              <div> Enquired <strong>{count}</strong> titles </div>
            ) : row.action === "File Viewer" ? (
              <div> Viewed <strong>{displayText}</strong> </div>
            ) : (
              <div>{displayText || "N/A"}</div>

            )}
          </div>
        );
      },
      grow: 3,
    }

  ];

  const handlePageChange = (page) => {
    GetTimeActivity()
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    GetTimeActivity()
    setRowsPerPage(newPerPage);
  };
  const customNoRecords = () => {
    return (

      <div className="empty-state-body empty-record"  >
        <div className="empty-state__message">
          <span className="material-icons">summarize</span>
          <p className="form-check font-size-16">No activities were found</p>
        </div> </div>
    )
  }
  return (
    <>

      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        <div className="main-content user-management viwe-client-search view_client_sessions">

          <div className="page-content">
            <div className="container-fluid">



              <div className="row mb-4 breadcrumb">
                <div className="col-lg-12">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h4 className="mb-2 card-title">View Client Sessions Report</h4>

                    </div>
                    <div>
                      <a onClick={handleBack} className="btn btn-primary">back</a>
                    </div>

                  </div>
                </div>
              </div>


              <div className="row table-data">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body view-client-activity">
                      {isLoading ? <TableLoader /> :
                        <>
                          <div className="row mb-3 top-wrapper">

                            <div className="item-wrapper">
                              <span className="material-symbols-outlined person-icon"> person </span>
                              <div className="txt-wrap">
                                <p>Client Name</p>
                                <h2>{contactData?.clientData?.[0]?.name}</h2>
                              </div>
                            </div>

                            <div className="item-wrapper">
                              {/* <span className="material-symbols-outlined person-icon"> person </span> */}
                              <div className="txt-wrap">
                                <p>Company Name</p>
                                <h2>{contactData?.clientData?.[0]?.companyname?.[0]}</h2>
                              </div>
                            </div>

                            <div className="item-wrapper">
                              {/* <span className="material-symbols-outlined person-icon"> person </span> */}
                              <div className="txt-wrap">
                                <p>Start Time</p>
                                <h2>  {new Date(contactData.login).toLocaleDateString('en-IN', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                  hour: 'numeric',
                                  minute: 'numeric',
                                })}</h2>

                              </div>
                            </div>

                            <div className="item-wrapper">
                              {/* <span className="material-symbols-outlined person-icon"> person </span> */}
                              <div className="txt-wrap">
                                <p>End Time</p>
                                <h2>
                                  {contactData?.loggedout
                                    ? new Date(contactData.loggedout).toLocaleDateString('en-IN', {
                                      day: 'numeric',
                                      month: 'short',
                                      year: 'numeric',
                                      hour: 'numeric',
                                      minute: 'numeric',
                                    })
                                    : null}
                                </h2>

                              </div>
                            </div>

                          </div>
                          < DataTable key={keyForRerender}
                            // title=""
                            columns={columns}

                            // className="table align-middle table-nowrap table-check"
                            keyField='_id'
                            data={activities}
                            direction="auto"
                            highlightOnHover
                            fixedHeaderScrollHeight="300px"
                            pagination
                            responsive
                            persistTableHead
                            // selectableRowsVisibleOnly
                            striped
                            // selectableRowsHighlight
                            // selectableRows
                            subHeaderAlign="right"
                            defaultSortField="name"
                            subHeaderWra
                            noDataComponent={customNoRecords()}
                            paginationTotalRows={activities.length}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationPerPage={rowsPerPage}
                            paginationDefaultPage={currentPageNew}
                            paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                            sortFunction={customSort}

                            paginationComponentOptions={{
                              rowsPerPageText: 'Per page:',
                              rangeSeparatorText: 'of',
                              noRowsPerPage: false,
                              selectAllRowsItem: false,
                              selectAllRowsItemText: 'All',
                            }}

                            progressPending={isLoading}
                          // progressComponent={<TableLoader />}

                          />
                          <div className="row mb-4">
                            <div className="col-sm-12">
                              <div className="d-flex align-items-center justify-content-center">
                                {/* <p className="menu-path">Client Name<b>{searchData.clientname}</b></p>
                                                 <p className="lg-badge badge">{type ? type : searchData.type}</p> */}
                              </div>
                            </div>

                            {/* <div className="col-sm-6">
                                                    
                                                 </div> */}
                          </div>

                          <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-check">

                              <tbody>
                                <tr>
                                  <td className="align-middle">Client name</td>
                                  <td className="align-middle">{contactData && contactData.clientData && contactData.clientData[0] && contactData.clientData[0].name ? contactData?.clientData[0]?.name : ""}</td>
                                </tr>
                                <tr>
                                  <td className="align-middle">Client email id</td>
                                  <td className="align-middle">{contactData && contactData.clientData && contactData.clientData[0] && contactData.clientData[0].personalemail ? contactData?.clientData[0]?.personalemail : ""}</td>
                                </tr>
                                <tr>
                                  <td className="align-middle">login time</td>
                                  <td className="align-middle">{contactData?.login ? new Date(contactData.login).toLocaleDateString('en-IN', {
                                    day: 'numeric',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: 'numeric',
                                    minute: 'numeric',
                                  }) : ""}</td>
                                </tr>
                                <tr>
                                  <td className="align-middle">logout time</td>
                                  <td className="align-middle">{contactData?.loggedout ? new Date(contactData.loggedout).toLocaleDateString('en-IN', {
                                    day: 'numeric',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: 'numeric',
                                    minute: 'numeric',
                                  }) : ""}</td>
                                </tr>

                                {contactData && contactData.useragent !== undefined && contactData.useragent &&


                                  Object.entries(contactData.useragent).map(([key, values]) => (
                                    <tr key={key}>
                                      <td className="align-middle">{key}</td>
                                      <td className="align-middle">{values[0].value}</td>
                                    </tr>
                                  ))


                                }
                              </tbody>

                            </table>
                          </div>

                        </>}

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>




        </div>
      </div>
    </>
  );
};

export default ViewClientSessions;
